import { Alert, Box, Stack, Typography } from "@mui/material"
import { RadioButtonGroup } from "lib/@components/radio-button-group/radio-button-group"
import Iconify from "minimals-template/components/Iconify"
import { confirm } from "lib/@dialogs/confirm"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useEffect } from "react"
import { busyWhile } from "lib/@components/busy/busy-while"
import { createRegimeFromRegister } from "routes/asset-register/controller/create-regime-from-register"
import { successSnackbar } from "lib/snackbar/success-snackbar"

export function RegimeStructureSelector() {
    const { syncType, regime, setSyncType, registers, allRegisters, currentRegimeStructure } = useBoundContext()
    const registersInRegimeWithData = registers.map((r) => allRegisters[r] ?? { id: r })
    useEffect(() => {
        updateRegister()
        async function updateRegister() {
            if (currentRegimeStructure !== null && currentRegimeStructure !== syncType) {
                await busyWhile(async () => {
                    for (const register of registersInRegimeWithData) {
                        await createRegimeFromRegister(register.id, regime._id, syncType)
                        currentRegimeStructure && successSnackbar("Structure successfully changed")
                    }
                }, "Building regime")
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [syncType])

    return (
        <Stack direction="row" spacing={2} alignItems="center" mr={0} mb={2} data-cy="regime-structure-switcher">
            <RadioButtonGroup
                label={"Synchronisation Method"}
                value={syncType}
                setterFunction={handleTypeChange}
                options={[
                    {
                        value: "spaces",
                        label: (
                            <Box alignItems="center" display="flex">
                                <Iconify icon="ic:round-account-tree" mr={1} height={18} width={18} />
                                <Typography variant="subtitle2">Group Regime by Asset Location</Typography>
                            </Box>
                        ),
                    },
                    {
                        value: "types",
                        label: (
                            <Box alignItems="center" display="flex">
                                <Iconify icon="bxs:folder" mr={1} height={18} width={18} />
                                <Typography variant="subtitle2">Group Regime by Asset Type</Typography>
                            </Box>
                        ),
                    },
                ]}
                sx={{ flexDirection: "column" }}
                optionSx={{ color: "grey.600", justifyContent: "flex-start" }}
            />
            <Box flex={1} alignContent="center" mt={0} pt={2.25}>
                <Alert severity="info">
                    Group the Maintenance Regime structure by Asset Location (e.g. space, facility, system) or by Asset
                    Type (e.g. Air Conditioning, Belts, Fans) from the SFG20 library. Changing this setting will affect
                    all associated Registers and will re-synchronise the Regime.
                </Alert>
            </Box>
        </Stack>
    )

    async function handleTypeChange(value) {
        if (
            await confirm(
                "Changing this option will re-synchronise all asset registers in the regime. This option can be reverted at any time.",
                "Are you sure you want to change the regime structure?"
            )
        ) {
            setSyncType(value)
        }
    }
}
